import React, { useState, useEffect } from 'react';
import { Accordion, AccordionBody } from '../common/Accordion';
import { getCountries, getCountryCode } from '../../actions/RegisterActions'
import { updateProfileDetail } from '../../actions/StudentAction';
import swal from 'sweetalert';

const FamilyDetail = (props) => {
    const detail = props.detail
    const [parentMobile, setParentMobile] = useState({ name: 'parentMobile', value: '', error: '', isRequired: false });
    const [parentEmail, setParentEmail] = useState({ name: 'parentEmail', value: '', error: '', isRequired: false });
    const [whatsappNumber, setWhatsappNumber] = useState({ name: 'whatsappNumber', value: '', error: '', isRequired: false });
    const [parentProfession, setParentProfession] = useState({ name: 'parentProfession', value: '', error: '', isRequired: false });
    const [designation, setDesignation] = useState({ name: 'designation', value: '', error: '', isRequired: false });
    const [parentCompany, setParentCompany] = useState({ name: 'company', value: '', error: '', isRequired: false });
    const [fatherName, setFatherName] = useState({ name: 'fatherName', value: '', error: '', isRequired: false });

    // Mother
    const [motherMobile, setMotherMobile] = useState({ name: 'motherMobile', value: '', error: '', isRequired: false });
    const [motherEmail, setMotherEmail] = useState({ name: 'motherEmail', value: '', error: '', isRequired: false });
    const [motherProfession, setMotherProfession] = useState({ name: 'motherProfession', value: '', error: '', isRequired: false });
    const [motherDesignation, setMotherDesignation] = useState({ name: 'motherDesignation', value: '', error: '', isRequired: false });
    const [motherCompany, setMotherCompany] = useState({ name: 'mothercompany', value: '', error: '', isRequired: false });
    const [motherName, setMotherName] = useState({ name: 'motherName', value: '', error: '', isRequired: false });
    
    
    const [countryCode, setCountryCode] = useState({ value: '', error: '', options: [], isRequired: false });
    const [editDetail, setEditDetail] = useState(false);
    const [fieldDisabled,setFieldDisabled] = useState(false);

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const detail = props.detail
        if (detail !== undefined) {
            setParentMobile({ ...parentMobile, value: detail.parent_mobile })
            setParentEmail({ ...parentEmail, value: detail.parent_email })
            setWhatsappNumber({ ...whatsappNumber, value: detail.whatsapp_number })
            setParentProfession({ ...parentProfession, value: detail.parent_profession })
            setDesignation({ ...designation, value: detail.parent_designation })
            setParentCompany({ ...parentCompany, value: detail.parent_company_name })
            setFatherName({ ...fatherName, value: detail.father_name })

            setMotherMobile({ ...motherMobile, value: detail.mother_mobile })
            setMotherEmail({ ...motherEmail, value: detail.mother_email })
            setMotherProfession({ ...motherProfession, value: detail.mother_profession })
            setMotherDesignation({ ...motherDesignation, value: detail.mother_designation })
            setMotherCompany({ ...motherCompany, value: detail.mother_company_name })
            setMotherName({ ...motherName, value: detail.mother_name })

            
            
        }
    }, [
         detail.father_name, 
         detail.parent_email,
         detail.parent_mobile,
         detail.whatsapp_number,
         detail.parent_profession,
         detail.parent_designation,
         detail.parent_company_name,
        detail.mother_mobile,
        detail.mother_email,
        detail.mother_profession,
        detail.mother_designation,
        detail.mother_company_name,
        detail.mother_name])


    const editPersonalDetail = () => {
        setEditDetail(true)
    }

    const handleCancel = () => {
        setEditDetail(false)
    }




    const validation = () => {
        const nameRegex = /^[a-zA-Z() ]+$/;
        let emailRegex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        let mobileRegex = /^\d+(\.\d{1,2})?$/;
        let formIsValid = true

        // Fahter Name
        if (!fatherName.value) {
            formIsValid = false
            let msg = "Please enter name"
            setFatherName({ ...fatherName, error: msg })
        }
        else if (fatherName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setFatherName({ ...fatherName, error: msg })
        }
        else if (fatherName.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setFatherName({ ...fatherName, error: msg })
        }
        else if (!nameRegex.test(fatherName.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setFatherName({ ...fatherName, error: msg })
        }

        // Mother Name
        if (!motherName.value) {
            formIsValid = false
            let msg = "Please enter name"
            setMotherName({ ...motherName, error: msg })
        }
        else if (motherName.value.length < 3) {
            formIsValid = false
            let msg = "Min 3 Character Length";
            setMotherName({ ...motherName, error: msg })
        }
        else if (motherName.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length";
            setMotherName({ ...motherName, error: msg })
        }
        else if (!nameRegex.test(motherName.value)) {
            formIsValid = false
            let msg = "Only Aplhabets should be acceptable No Numbers, Special Characters etc";
            setMotherName({ ...motherName, error: msg })
        }

        // Parent Mobile
        if (!parentMobile.value) {
            formIsValid = false
            let msg = "Please enter  mobile number"
            setParentMobile({ ...parentMobile, error: msg })
        }
        
        else if (parentMobile.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setParentMobile({ ...parentMobile, error: msg })
        }
        else if (parentMobile.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setParentMobile({ ...parentMobile, error: msg })
        }
        else if (!mobileRegex.test(parentMobile.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setParentMobile({ ...parentMobile, error: msg })
        }

        // mother Mobile
        if (!motherMobile.value) {
            formIsValid = false
            let msg = "Please enter mobile number"
            setMotherMobile({ ...motherMobile, error: msg })
        }
        
        else if (motherMobile.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setMotherMobile({ ...motherMobile, error: msg })
        }
        else if (motherMobile.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setMotherMobile({ ...motherMobile, error: msg })
        }
        else if (!mobileRegex.test(motherMobile.value)) {
            formIsValid = false
            let msg = "Enter a valid Mobile Number"
            setMotherMobile({ ...motherMobile, error: msg })
        }

        // Parent Email
        if (!parentEmail.value) {
            formIsValid = false
            let msg = "Please enter your father email"
            setParentEmail({ ...parentEmail, error: msg })
        }
        else if (parentEmail.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setParentEmail({ ...parentEmail, error: msg })
        }
        else if (parentEmail.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setParentEmail({ ...parentEmail, error: msg })
        }
        
        else if (!emailRegex.test(parentEmail.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setParentEmail({ ...parentEmail, error: msg })
        }

        // Mother Email
        if (!motherEmail.value) {
            formIsValid = false
            let msg = "Please enter your mother email"
            setMotherEmail({ ...motherEmail, error: msg })
        }
        else if (motherEmail.value.length < 13) {
            formIsValid = false
            let msg = "Min 3 Character Length"
            setMotherEmail({ ...motherEmail, error: msg })
        }
        else if (motherEmail.value.length > 64) {
            formIsValid = false
            let msg = "Max 64 Character Length"
            setMotherEmail({ ...motherEmail, error: msg })
        }
        
        else if (!emailRegex.test(motherEmail.value)) {
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setMotherEmail({ ...motherEmail, error: msg })
        }

        // Whatsapp number
        if (!whatsappNumber.value) {
            formIsValid = false
            let msg = "Please enter whatsapp number"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        
        else if (whatsappNumber.value.length <= 5) {
            formIsValid = false
            let msg = "Min 6 Digit Length"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        else if (whatsappNumber.value.length >= 17) {
            formIsValid = false
            let msg = "Max 16 Digit Length"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }
        else if (!mobileRegex.test(whatsappNumber.value)) {
            formIsValid = false
            let msg = "Enter a valid Whatsapp Mobile Number"
            setWhatsappNumber({ ...whatsappNumber, error: msg })
        }

        // Profession
        if (!parentProfession.value) {
            formIsValid = false
            let msg = "Please enter profession"
            setParentProfession({ ...parentProfession, error: msg })
        }

        // Profession
        if (!designation.value) {
            formIsValid = false
            let msg = "Please enter designation"
            setDesignation({ ...designation, error: msg })
        }

        // Mother Profession
        if (!motherProfession.value) {
            formIsValid = false
            let msg = "Please enter profession"
            setMotherProfession({ ...motherProfession, error: msg })
        }

        // Mother Profession
        if (!motherDesignation.value) {
            formIsValid = false
            let msg = "Please enter designation"
            setMotherDesignation({ ...motherDesignation, error: msg })
        }


        if (formIsValid) {
            setParentMobile({ ...parentMobile, error: '' });
            setParentEmail({ ...parentEmail, error: '' });
            setWhatsappNumber({ ...whatsappNumber, error: '' });
            setParentProfession({ ...parentProfession, error: '' });
            setDesignation({ ...designation, error: '' });
            setFatherName({ ...fatherName, error: '' })

            setMotherMobile({ ...motherMobile, error: '' });
            setMotherEmail({ ...motherEmail, error: '' });
            setMotherProfession({ ...motherProfession, error: '' });
            setMotherDesignation({ ...motherDesignation, error: '' });
            setMotherName({ ...motherName, error: '' })
        }

        return formIsValid;

    }


    const onSubmit = async (e) => {
        e.preventDefault();
        
        if (validation()) {
            setLoading(true)
            const data = {
                father_name: fatherName.value,
                parent_mobile:parentMobile.value,
                parent_email:parentEmail.value,
                whatsapp_number:whatsappNumber.value,
                parent_profession:parentProfession.value,
                parent_designation:designation.value, 
                parent_company_name : parentCompany.value,

                mother_name: motherName.value,
                mother_mobile:motherMobile.value,
                mother_email:motherEmail.value,
                mother_profession:motherProfession.value,
                mother_designation:motherDesignation.value,
                mother_company_name : motherCompany.value
            }

            data.id = detail.id
            await updateProfileDetail(data).then(res => {
                if (res.status) {
                    setEditDetail(false)
                    setLoading(false)
                    swal('Data updated successfully', '', 'success')
                    props.onSubmit(res)
                }
                else {
                    swal('Something went wrong', '', 'error')
                    setLoading(false)
                }
            })
                .catch(err => {
                    console.log(err);
                })
        }

    }

    return (
        <>
            <Accordion title="Family Details" collapseName="editFamilyDetail" id={"family-details"}>
                <AccordionBody>
                    <form className="hold_mandatoryField" >

                        <div className="row mb-4">
                            <h5 style={{fontSize:'16px',fontWeight:'700'}}>Father Detail</h5>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                <input type="text" className="form-control" disabled={!editDetail} name="fatherName" placeholder="Father Name"
                                    value={fatherName.value!==null?fatherName.value:''} onChange={(e) => {
                                        let value = e.target.value
                                        value = value.replace(/[^A-Za-z- ]/ig, '')
                                        setFatherName({ ...fatherName, value: value, error: '' })
                                    }
                                    }
                                />
                                <label>Father Name</label>
                                </div>
                                {fatherName.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{fatherName.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="number" className="form-control" name="parentMobile"
                                        placeholder="Father Mobile Number"   disabled={!editDetail} maxLength="16" value={parentMobile.value!==null?parentMobile.value:''} onChange={(e) =>
                                            setParentMobile({ ...parentMobile, value: e.target.value, error: '' })} 
                                    />
                                    <label >Father Mobile Number</label>
                                </div>
                                {parentMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentMobile.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="parentEmail" 
                                        placeholder="Student's Mobile"   disabled={!editDetail} value={parentEmail.value!==null?parentEmail.value:''} 
                                        onChange={(e) =>
                                            setParentEmail({ ...parentEmail, value: e.target.value, error: '' })} 
                                    />
                                    <label >Father Email Id</label>
                                </div>
                                {parentEmail.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentEmail.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="number" className="form-control" name="whatsNumber"
                                        placeholder="WhatsApp Number"  disabled={!editDetail} value={whatsappNumber.value!==null?whatsappNumber.value:''} 
                                        maxLength="16"
                                        onChange={(e) =>
                                            setWhatsappNumber({ ...whatsappNumber, value: e.target.value, error: '' })} 
                                    />
                                    <label >WhatsApp Number</label>
                                </div>
                                {whatsappNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{whatsappNumber.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="parentProfession"
                                        placeholder="Father profession"   disabled={!editDetail} value={parentProfession.value!==null?parentProfession.value:''}
                                        onChange={(e) =>
                                            setParentProfession({ ...parentProfession, value: e.target.value, error: '' })} 
                                    />
                                    <label >Father Profession</label>
                                </div>
                                {parentProfession.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentProfession.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="designation"
                                        placeholder="parent profession"   disabled={!editDetail} value={designation.value!==null?designation.value:''}
                                        onChange={(e) =>
                                            setDesignation({ ...designation, value: e.target.value, error: '' })} 
                                    />
                                    <label >Father Designation</label>
                                </div>
                                {designation.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{designation.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="company"
                                        placeholder="Organization Name"   disabled={!editDetail} value={parentCompany.value!==null?parentCompany.value:''}
                                        onChange={(e) =>
                                            setParentCompany({ ...parentCompany, value: e.target.value, error: '' })} 
                                    />
                                    <label >Father Organization Name</label>
                                </div>
                                {parentCompany.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentCompany.error}</div>}
                            </div>

                            <h5 style={{fontSize:'16px',fontWeight:'700'}}>Mother Detail</h5>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                <input type="text" className="form-control" disabled={!editDetail} name="mothername" placeholder="Mother Name"
                                    value={motherName.value!==null?motherName.value:''} onChange={(e) => {
                                        let value = e.target.value
                                        value = value.replace(/[^A-Za-z- ]/ig, '')
                                        setMotherName({ ...motherName, value: value, error: '' })
                                    }
                                    }
                                />
                                <label>Mother Name</label>
                                </div>
                                {motherName.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherName.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="number" className="form-control" name="motherMobile"
                                        placeholder="Mother Mobile Number"   disabled={!editDetail} maxLength="16" value={motherMobile.value!==null?motherMobile.value:''} onChange={(e) =>
                                            setMotherMobile({ ...motherMobile, value: e.target.value, error: '' })} 
                                    />
                                    <label >Mother Mobile Number</label>
                                </div>
                                {motherMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherMobile.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="motherEmail" 
                                        placeholder="Mother's Mobile"   disabled={!editDetail} value={motherEmail.value!==null?motherEmail.value:''} 
                                        onChange={(e) =>
                                            setMotherEmail({ ...motherEmail, value: e.target.value, error: '' })} 
                                    />
                                    <label >Mother Email Id</label>
                                </div>
                                {motherEmail.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherEmail.error}</div>}
                            </div>
              
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="motherProfession"
                                        placeholder="Mother profession"   disabled={!editDetail} value={motherProfession.value!==null?motherProfession.value:''}
                                        onChange={(e) =>
                                            setMotherProfession({ ...motherProfession, value: e.target.value, error: '' })} 
                                    />
                                    <label >Mother Profession</label>
                                </div>
                                {motherProfession.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherProfession.error}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="motherDesignation"
                                        placeholder="Mother Designation"   disabled={!editDetail} value={motherDesignation.value!==null?motherDesignation.value:''}
                                        onChange={(e) =>
                                            setMotherDesignation({ ...motherDesignation, value: e.target.value, error: '' })} 
                                    />
                                    <label >Mother Designation</label>
                                </div>
                                {motherDesignation.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherDesignation.error}</div>}
                            </div>

                            <div className="col-lg-6 mb-3">
                                <div className="form-floating diff_disable">
                                    <input type="text" className="form-control" name="company"
                                        placeholder="Mother's Organization Name"   disabled={!editDetail} value={motherCompany.value!==null?motherCompany.value:''}
                                        onChange={(e) =>
                                            setMotherCompany({ ...motherCompany, value: e.target.value, error: '' })} 
                                    />
                                    <label >Mother's Organization Name</label>
                                </div>
                                {motherCompany.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{motherCompany.error}</div>}
                            </div>
                           
             

                            
                            <div className='w-100'></div>
                            {editDetail ? <div className="col-lg-2">
                            {loading ? (<button type="submit" disabled className="btn btn-primary d-inline-block btn-md w-auto auth_btn">
                        <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                        Updating..</button>) :
                            <input type="button" className="btn btn-primary" value="Save" onClick={onSubmit} />
                    }
                            </div>
                                :
                                <div className="col-lg-2">
                                    
                                     <input type="button" className="btn btn-primary" value="Edit" onClick={editPersonalDetail} /> 
                                    
                                    
                                </div>}

                            {editDetail && <div className="col-lg-2">
                                <input type="button" className="btn btn-primary" value="Cancel" onClick={handleCancel} />
                            </div>}

                        </div>
                    </form>
                </AccordionBody>
            </Accordion>
        </>
    )
}

export default FamilyDetail
